<template>
  <div class="columns is-multiline is-mobile is-variable is-3-desktop is-2-mobile">
    <search-track-list-item
      v-for="track in tracks"
      v-bind:key="track.id"
      v-bind:track="track"
    ></search-track-list-item>
  </div>
</template>

<script>
  import SearchTrackListItem from '@/components/SearchTrackListItem'

  export default {
    name: 'SearchTrackList',
    components: {
      SearchTrackListItem
    },
    props: {
      tracks: {
        type: Array,
        required: true
      }
    }
  }
</script>
